<template>
  <div class="container-modal-auth">
    <div class="close">
      <span @click="$emit('click-close-modal-auth')">x</span>
    </div>
    <div class="info">
      <span>
        The quickbooks auth token is out of date, please authenticate again using the button below!
      </span>
      <div class="auth-button" @click="$emit('click-auth')">
        Authenticate
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'modal-auth-update',
};
</script>

<style lang="scss">
.close {
  position: fixed;
  right: 29vw;
  top: 35.5vh;
  cursor: pointer;
  span {
    font-size: 1.4rem;
    color: $header;
    @media (max-width: 960px) {
      font-size: 3rem;
    }
  }
  @media (max-width: 960px) {
    right: 8vw;
    top: 5vh;
  }
}
.container-modal-auth {
  position: fixed;
  display: flex;
  align-items: center;
  z-index: 10;
  top: 0;
  width: 100%;
  height: 100vh;
  background: rgba(48, 48, 48, 0.5);
  .info {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-direction: column;
    background-color: $white;
    width: 44.2vw;
    height: 30.5vh;
    border-radius: 10px;
    @media (max-width: 960px) {
      width: 100%;
      height: 100%;
      border-radius: 0px;
    }
    span {
      font-weight: 500;
      font-size: 1em;
      letter-spacing: 0.274837px;
      color: $black;
      margin-top: 20px;
      padding: 0 125px;
    }
  }
  .auth-button {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    padding: 5px 25px;
    border-radius: 40px;
    cursor: pointer;
    background-color: $backgroundData;
    border: 2px solid $header;
  }
}
</style>
